export * from './Functions'
export * from './LocalDocument'

type LibraryInitType = {
  packageName: string
  platform: 'ios' | 'android' | 'web'
  webVersion: string // 웹 버전
  appVersion: string | null // 앱 버전 (ios는 CFBundleShortVersionString, android는 build.gradle의 versionName)
  storagePath?: 'local' | 'none'
  isWeb?: boolean
}

export const Lib = {
  packageName: '',
  platform: '',
  isWeb: false,
  webVersion: '',
  appVersion: null as string | null,
  storagePath: 'none' as 'local' | 'none',
  account: '',
  Init: async (config: LibraryInitType): Promise<void> => {
    Lib.packageName = config.packageName
    Lib.platform = config.platform
    Lib.webVersion = config.webVersion
    Lib.appVersion = config.appVersion
    if (config.storagePath) Lib.storagePath = config.storagePath
    if (config.isWeb !== undefined) Lib.isWeb = config.isWeb
  },
}
